import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
import { encryptionHostLive } from "@/api/php/player";
import { useRouter } from "vue-router";
import { uitlsToLiveRoom } from "@/uitls/uitls";

export default /*#__PURE__*/_defineComponent({
  name: 'Live',
  setup(__props, { expose }) {
  expose();

const router = useRouter();
const livezb = require(`@/assets/${process.env.VUE_APP_NAME}/live-gif.gif`)
const livejj = require(`@/assets/${process.env.VUE_APP_NAME}/home_gif_mp4.gif`)
const liveqy = require(`@/assets/${process.env.VUE_APP_NAME}/live-ys-gif.gif`)
// const livetj = require(`@/assets/${process.env.VUE_APP_NAME}/home-match-rec.png`)
const livepb = require(`@/assets/${process.env.VUE_APP_NAME}/live_pb.gif`)

onMounted(() => {
  getData();
});

const toLiveRoom = (data) => {
  uitlsToLiveRoom(data, router)
};
let data = ref([]);
const getData = async () => {
  //   直播数据
  const res: any = await encryptionHostLive();
  if (res.code == 200) {
    data.value = res.data;
  }
};
function formatNum(num) {
  if (num > 100000000) {
    return (num / 100000000).toFixed(0) + "亿";
  } else if (num > 10000) {
    if (num > 1000000) {
      return (num / 10000).toFixed(0) + "万";
    } else if (num > 100000) {
      return (num / 10000).toFixed(1) + "万";
    }
  }
  return num;
}
//判断有主播的，还是清源
const checkZb = (data) => {
  if (data.room_id && data.room_id != "") {
    //有主播的
    return 0;
  } else if (
    data.match_id &&
    data.match_type &&
    data.match_id != "" &&
    data.live_url &&
    data.live_url != ""
  ) {
    //清源
    return 1;
  } else if (data.live_type == 4) {
    //mp4
    return 4
  } else {
    return 2
  }
}

const __returned__ = { router, livezb, livejj, liveqy, livepb, toLiveRoom, data, getData, formatNum, checkZb }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})